import React, { useRef } from 'react';
import { FilterLink } from '@searchkit/client';
import Button from '../../../../Button';
var ValueFilter = function ValueFilter(_ref) {
  var filter = _ref.filter,
    loading = _ref.loading;
  var ref = useRef();
  return /*#__PURE__*/React.createElement(Button, {
    disabled: loading,
    onClick: function onClick(e) {
      ref.current.onClick(e);
    }
  }, /*#__PURE__*/React.createElement(FilterLink, {
    ref: ref,
    filter: filter
  }, filter.label, ": ", filter.value));
};
export default ValueFilter;